import Box from "@mui/material/Box"
import { Outlet } from "react-router-dom"

import Column from "../../common/components/Column"
import Row from "../../common/components/Row"
import AuthBrandHeader from "./components/AuthBrandHeader"
import AuthRecruitingInfographic from "./components/AuthRecruitingInfographic"
import { userAuthLayoutBackgroundSx, userAuthPageSx } from "./userAuthStyles"

export default function UsersLayout() {
  return (
    <Row
      sx={{
        minHeight: "100vh",
        width: "100%",
        ...userAuthLayoutBackgroundSx,
        ...userAuthPageSx,
      }}
    >
      <AuthRecruitingInfographic />

      <Column
        sx={{
          flex: { xs: 1, md: "0 0 480px", lg: "0 0 520px" },
          minHeight: "100vh",
          justifyContent: "center",
          alignItems: "center",
          px: { xs: 3, sm: 6 },
          py: 4,
          boxShadow: { md: "-8px 0 32px rgba(10, 37, 64, 0.08)" },
          fontFamily: "Inter, sans-serif",
          backdropFilter: "blur(21px)",
          background:
            "linear-gradient(159deg, rgba(255, 255, 255, 0.92) 3%, rgba(255, 255, 255, 0.78) 100%)",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 380,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <AuthBrandHeader />
          <Outlet />
        </Box>
      </Column>
    </Row>
  )
}
